import React from "react";
//import { Link } from 'react-router-dom'
import Buscador from "./Buscador";
//import Banner from './Banner'
//import BannerEstatico from './BannerEstatico'

//import {manejadorDeRespuesta} from '../../../utils/Tools'

//import carouselSettings from "../carouselSettings";
import BuscadorHotel from "../../Hoteles/BuscadorHotel";
//import {RUTA_IMAGEN} from '../../../utils/rutasFijas'

const SeccionBuscador = (props) => {
  // const [bannerFijo, setBannerFijo] = useState({});
  // const [bannersSlider, setBannersSlider] = useState([]);
  const {
    origen,
    onSelectChange,
    onSelectOrigenChange,
    onSelectDestinoChange,
    onAdultosChange,
    onMenoresChange,
    onEdadChange,
    busqueda,
  } = props;

  /*
  const traerBannersIniciales = (origen) => {
    let data = JSON.stringify({ accion: "traerBannersDeHome", origen: origen });

    toolsAPI(data).then((respuesta) => {
      //if (manejadorDeRespuesta(_this.props, respuesta)) {
      if (respuesta) {
        if (respuesta.estado !== "error") {
          //let primerProducto = respuesta.data.shift();
          //this.setState({bannersSlider: respuesta.data, bannerFijo: primerProducto});
          setBannersSlider(respuesta.data);
        }
      }
    });
  };
  
  useEffect(() => {
    traerBannersIniciales(origen);
  }, [origen]);
  */
  const handleCombosBusquedaChange = (propiedad, valor) => {
    onSelectChange(propiedad, valor);
  };

  const handleCombosOrigenBusquedaChange = (valor) => {
    onSelectOrigenChange(valor);
  };

  const handleCombosDestinoBusquedaChange = (valor) => {
    onSelectDestinoChange(valor);
  };

  const handleAdultosChange = (fecha) => {
    onAdultosChange(fecha);
  };

  const handleMenoresChange = (fecha) => {
    onMenoresChange(fecha);
  };

  const handleEdadChange = (clave, valor) => {
    onEdadChange(clave, valor);
  };

  //let settings = carouselSettings[4];
  const estilos = {
    estilo1: "form-row",
    estilosInputs: "col-xl-2 col-lg-2 col-md-6 col-sm-6 col-12",
    estilosHabitaciones: "col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12",
    estilosInputFecha:
      "col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12",
    estiloBoton: "col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12",
    estiloEdadMenor: "col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6",
    estilosDestinos: "col-xl-3 col-lg-2 col-md-6 col-sm-6 col-12",
    estilosAdultosMenores: "col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12",
  };
const backgroundColor = origen === 'CDR' ? '#16853c' : '#181e35';
  return (
    <section className="atf">
      {/*
      FC: nuevo banners rotativos
      <div
        className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 carousel-paquetes"
        style={{ padding: "0px" }}
      >
        {bannersSlider.length > 0 ? (
          <Slider {...settings}>
            {bannersSlider.map((banner, index) => {
              banner.link ? (banner.link = banner.link) : (banner.link = "/");
              return (
                <a key={index} href={banner.link}>
                  <div className="bg">
                    <img
                      className="bannerHome"
                      alt="Promociones"
                      src={`${origen === "CDR" ? '../' : ''}assets/img/paquetes/bg/${banner.imagen}`}
                    />
                  </div>
                </a>
              );
            })}
          </Slider>
        ) : null}
      </div>
      */}
      {/*FC: FIN BANNER NUEVOS*/}
      <div className="container-fluid">
        {/* ----FORM ------ */}
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 form" style={{backgroundColor}}>
          {origen !== "CDR" && (
            <Buscador
              busqueda={busqueda}
              estilos={estilos}
              onSelectChange={handleCombosBusquedaChange}
              onSelectOrigenChange={handleCombosOrigenBusquedaChange}
              onSelectDestinoChange={handleCombosDestinoBusquedaChange}
              onAdultosChange={handleAdultosChange}
              onMenoresChange={handleMenoresChange}
              onEdadChange={handleEdadChange}
              solosYsolas={false}
            />
          )}

          {origen === "CDR" && (
            <BuscadorHotel estilos={estilos} />
          )}
        </div>
        {/* paquete destacado estatico
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 paquete-static">
               <a href={bannerFijo.link} className="bg" style={{backgroundImage: 'url(assets/img/paquetes/bg/' + bannerFijo.imagen + ')'}}><div></div></a>
              </div> */}
        {/* carrusel de paquetes
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 carousel-paquetes">

              { bannersSlider.length > 0 ? <Slider {...settings} >
                {
                  bannersSlider.map((banner, index) => {
                     return  <div key={index} >
                                <a href={banner.link} className="bg" style={{backgroundImage: 'url(assets/img/paquetes/bg/' + banner.imagen + ')'}}><div></div></a>
                             </div>
                   })
                }
                </Slider> : null }

                  </div> */}
      </div>
    </section>
  );
};

export default SeccionBuscador;

/*
<a className="carousel-control-prev" href="#carouselPaquetes" role="button" data-slide="prev">
  <div className="overlay"><span className="carousel-control-prev-icon" aria-hidden="true"></span></div>
  <span className="sr-only">Anterior</span>
</a>
<a className="carousel-control-next" href="#carouselPaquetes" role="button" data-slide="next">
  <div className="overlay"><span className="carousel-control-next-icon" aria-hidden="true"></span></div>
  <span className="sr-only">Siguiente</span>
</a>
----------
<div id="carouselPaquetes" className="carousel slide" data-ride="carousel">
  <ol className="carousel-indicators">
    {bannersSlider.map((producto, index) => {
       return  <li key={index} data-target="#carouselPaquetes" data-slide-to={index}></li>
     })}
  </ol>
  <div className="carousel-inner">
    {bannersSlider.map((banner, index) => {
       return  <div key={index} className={index === 0 ? 'carousel-item active' : 'carousel-item'}>
                  <a href={banner.link} className="bg" style={{backgroundImage: 'url(assets/img/paquetes/bg/' + banner.imagen + ')'}}><div></div></a>
               </div>
     })}
      </div>

    </div>
*/



// WEBPACK FOOTER //
// ./src/components/Home/SeccionBuscador/index.js